import { Duration } from "luxon";

import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";
import { IBFRecord } from "@/lib/drivers/insulet/IBFRecords/IBFRecord";

export type IBFDateChange = {
  timeDifference: Duration;
};

export const IBF_DATE_CHANGE = {
  value: 0x0040,
  name: "IBF_DATE_CHANGE",
  size: 4,
  parse: (record: IBFRecord): IBFDateChange => {
    const day = record.nextUInt8();
    const month = record.nextUInt8();
    const year = record.nextUInt16LE();
    const timeDifference = Duration.fromObject({ day, month, year });
    return { timeDifference };
  },
} satisfies IBFHistoryRecordDefinition<IBFDateChange>;
